
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Portfolio } from "./components/Portfolio";
import { Process } from "./components/Process";
import { About } from "./components/About";
import { Pricing } from "./components/Pricing";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatYouGet } from "./components/Whatyouget";
import { Maintenance } from './components/Maintenance';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import TrustedBy from './components/TrustedBy';


const Home = () => (
  <main className="grain bg-[#040814] text-white min-h-screen">
    <Navbar />
    <Hero />
    <TrustedBy />
    <Services />
    <WhatYouGet />
    <Portfolio />
    <Process />
    <About />
    <Testimonials />
    <Pricing />
    <Maintenance />
    <FAQ />
    <Contact />
    <Footer />
    <Analytics />
    <SpeedInsights />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/demo" element={<RubyDemo />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;



// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
